import {
  NgModule,
  provideBrowserGlobalErrorListeners,
  CUSTOM_ELEMENTS_SCHEMA,
  Injector,
  PLATFORM_ID,
  Inject,
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { createCustomElement } from '@angular/elements';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Content } from '@builder.io/sdk-angular';
import { AppRoutingModule } from './app-routing-module';
import { App } from './app';
import { BuilderPageComponent } from './pages/builder-page/builder-page.component';
import { HeroSectionComponent } from './components/hero-section/hero-section.component';
import { UserCardsComponent } from './components/user-cards/user-cards.component';
import { AcademicIntegrityComponent } from './components/academic-integrity/academic-integrity.component';
import { LearningScienceComponent } from './components/learning-science/learning-science.component';
import { DemoComponent } from './pages/demo/demo.component';
import { BlogPromoPreviewComponent } from './pages/blog-promo-preview/blog-promo-preview.component';
import { BlogPromoSectionComponent } from './components/blog-promo-section/blog-promo-section.component';
import { YoutubeVideoComponent } from './components/youtube-video/youtube-video.component';
import { SafeUrlPipe } from './pipes/safe-url.pipe';
import { ArticleListingComponent } from './components/article-listing/article-listing.component';
import { ArticleCardComponent } from './components/article-card/article-card.component';
import { BrowseByCategoryComponent } from './components/browse-by-category/browse-by-category.component';

@NgModule({
  declarations: [
    App,
    BuilderPageComponent,
    HeroSectionComponent,
    UserCardsComponent,
    AcademicIntegrityComponent,
    LearningScienceComponent,
    DemoComponent,
    BlogPromoPreviewComponent,
    YoutubeVideoComponent,
    SafeUrlPipe,
    ArticleListingComponent,
    BrowseByCategoryComponent,
  ],
  imports: [BrowserModule, CommonModule, FormsModule, AppRoutingModule, Content, BlogPromoSectionComponent, ArticleCardComponent],
  exports: [FormsModule],
  providers: [provideBrowserGlobalErrorListeners()],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [App],
})
export class AppModule {
  constructor(
    private injector: Injector,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    // Only register custom element in browser environment (not during SSR)
    if (isPlatformBrowser(this.platformId)) {
      // Register youtube-video as a custom element so it can be used in HTML content
      const youtubeVideoElement = createCustomElement(YoutubeVideoComponent, { injector });
      
      // Check if already defined to avoid errors on hot reload
      if (!customElements.get('youtube-video')) {
        customElements.define('youtube-video', youtubeVideoElement);
      }
    }
  }
}
